import { render, staticRenderFns } from "./AppGithubCorner.vue?vue&type=template&id=553b04e0&scoped=true&"
import script from "./AppGithubCorner.vue?vue&type=script&lang=js&"
export * from "./AppGithubCorner.vue?vue&type=script&lang=js&"
import style0 from "./AppGithubCorner.vue?vue&type=style&index=0&id=553b04e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b04e0",
  null
  
)

export default component.exports